// extracted by mini-css-extract-plugin
export default {"bubble":"Step_bubble__9+cjK","content":"Step_content__5eeye","title":"Step_title__VFbvE","description":"Step_description__AtVn7","lessonNumber":"Step_lessonNumber__C2O5z"};